import { actionTypes } from "./pendingInvoices.actions";

export interface IOverdueInvoicePetInfo {
  petId: string;
  petName: string;
  publicUrl?: string;
  invoiceDueDate?: string;
  dueAmount?: string;
  planName?: string;
}
export interface IOverdueInvoiceOverallInfo {
  petId: string;
  petName: string;
  pendingInvoices: number;
  endDate: string;
  wellnessPlanPaymentStatus: string;
  publicUrl?: string;
  petImage?: string;
  invoiceDueDate?: string;
  dueAmount?: string;
  planName?: string;
}
export interface IOverdueInvoiceState {
  cancelledWellnessPetList: IOverdueInvoicePetInfo[];
  overdueWellnessPetList: IOverdueInvoicePetInfo[];
  pausedWellnessPetList: IOverdueInvoicePetInfo[];
  pendingPaymentPetList: IOverdueInvoiceOverallInfo[];
  cancelledPetListWithoutOverdue: IOverdueInvoicePetInfo[];
  scratchpayOverdueNoticePetIds: string[];
  isOverdueStoreUpdated: boolean;
}

const initialState: IOverdueInvoiceState = {
  cancelledWellnessPetList: [],
  overdueWellnessPetList: [],
  pausedWellnessPetList: [],
  pendingPaymentPetList: [],
  cancelledPetListWithoutOverdue: [],
  scratchpayOverdueNoticePetIds: [],
  isOverdueStoreUpdated: false,
};


export const overdueInvoiceReducer = (
  state: IOverdueInvoiceState = initialState,
  action: { type: string, payload: any },
) => {
  switch (action.type) {
  case actionTypes.SET_CANCELLED_PET_LIST:
    return {
      ...state,
      cancelledWellnessPetList: action.payload,
    };
  case actionTypes.SET_PAUSED_PET_LIST:
    return {
      ...state,
      pausedWellnessPetList: action.payload,
    };
  case actionTypes.SET_OVERDUE_PET_LIST:
    return {
      ...state,
      overdueWellnessPetList: action.payload,
    };
  case actionTypes.SET_PENDING_PAYMENT_PET_LIST:
    return {
      ...state,
      pendingPaymentPetList: action.payload,
    };
  case actionTypes.SET_SCRATCHPAY_OVERDUE_NOTICE_PET_IDS:
    return {
      ...state,
      scratchpayOverdueNoticePetIds: action.payload,
    };
  case actionTypes.SET_IS_OVERDUE_STORE_UPDATED:
    return {
      ...state,
      isOverdueStoreUpdated: action.payload,
    };
  case actionTypes.RESET_OVERDUE_INVOICE_STORE:
    return {
      ...initialState,
    };
  case actionTypes.SET_CANCELLED_PET_LIST_WITHOUT_OVERDUE:
    return {
      ...state,
      cancelledPetListWithoutOverdue: action.payload,
    };
  default:
    return state;
  }
};
